<template>
   <div id="index">
        <el-container style="height:100%;">
              <el-aside width="100px" style="background-color: #366c9b; ">
                <menu :height="height" :width="100"></menu>
                 <div class="systemInfo">
                   <div style="margin-bottom: 30px;color: #81cef2;">{{user_info.username}}</div>
                   <div  @click="switch_page(2)" class="category_btn" :class="{'typeSelected':message_type==2}">项目</div>
                   <div  @click="switch_page(3)" class="category_btn" :class="{'typeSelected':message_type==3}">审批</div>
                   <div class="category_btn" @click="loginout">退出</div>

                   <div class="downloadTips">
                      <div>安装安卓白马</div>
                      <div>项目管理APP</div>
                      <img :src="appUrl" alt="" class="appUrl">
                   </div>
                 </div>
              </el-aside>

              <el-main v-if="message_type==3" :style="'padding: 0 0 0 110px!important;height:'+height+'px;'">
                <el-checkbox label="我审批" v-model="getDataParam.my_approval" @change="updateData(1)"></el-checkbox>
                <el-checkbox label="我发起" v-model="getDataParam.my_create" @change="updateData(1)"></el-checkbox>
                <div>
                  <el-checkbox label="进行中" v-model="getDataParam.underway" @change="updateData(1)"></el-checkbox>
                  <el-checkbox label="已完成" v-model="getDataParam.is_finish" @change="updateData(1)"></el-checkbox>
                  <el-checkbox label="审批失败" v-model="getDataParam.is_failure" @change="updateData(1)"></el-checkbox>
                  <el-checkbox label="我已审批" v-model="getDataParam.is_correct" @change="updateData(1)"></el-checkbox>
                  <el-checkbox label="已终止" v-model="getDataParam.is_abend" @change="updateData(1)"></el-checkbox>
                </div>

                <div class="bar">
                    <span>
                            共{{lists.count}}条
                      </span>
                    <div class="fr">
                      排序
                      <el-select v-model="getDataParam.order_by" placeholder="请选择" @change="updateData(1)">
                        <el-option
                          v-for="item in order_by"
                          :key="item.value"
                          :label="item.lable"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-model="getDataParam.sort" placeholder="请选择" @change="updateData(1)">
                        <el-option
                          v-for="item in sort"
                          :key="item.value"
                          :label="item.lable"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <el-button type="primary" @click="dialogAdd_approval = true">新建审批</el-button>
                    </div>
                </div>

                  <div :style="'height:'+(height-120)+'px;overflow: auto;'">
                    <v-audit :lists="lists" :height="height-120" :width="width" v-if="web_token != undefined" :web_token="web_token" :templates="templates" v-on:listenToChildEvent="updateData(1)"></v-audit>
                  </div>
                  <el-pagination
                    @current-change="updateData"
                    background
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="lists.count"
                    style="padding:5px;"
                    >
                  </el-pagination>
              </el-main>
            <!-- </el-container> -->
        </el-container>

     <!--添加审批-->
     <el-dialog
        title="新建审批"
         :visible.sync="dialogAdd_approval"
          width="1000px"
         :before-close="handleClose"
         style="overflow:hidden"
         >
       <div class="approval" v-if="data_ok" :style="'height:'+(height/2)+'px'">
         <!--:class="{'moduel_input':item.type!='select_flow'}"-->
         <!--<v-templates_params :params="params0" v-if="dialogVisible"></v-templates_params>-->
         <div  v-for="(item,index) in templates_approval" :key="index+''" >
           <v-input v-if="item.type=='input'" :moduel="item" :projectData ="approval_data"  :ref="'approval'+item.key_name" :input_callback="set_add_project_input" :projectNum="projectNum" v-model='approval_data[item.key_name]' type='audit'></v-input>
           <v-select v-if="item.type=='select'" :moduel="item" :projectData.sync ="approval_data"  v-model='approval_data[item.key_name]' :ref="'approval'+item.key_name" type='audit'> </v-select>
           <v-select_flow v-if="item.type=='select_flow'" :moduel.sync="item" :projectData.sync="approval_data" v-model='approval_data[item.key_name]' :ref="'approval'+item.key_name" type='audit'> </v-select_flow>
           <v-select_flow v-if="item.type=='select_project_user'" :moduel.sync="item" :projectData.sync="approval_data" v-model='approval_data[item.key_name]'  :ref="'approval'+item.key_name" type='audit'> </v-select_flow>
           <!-- <v-text v-if="item.type=='text'" :moduel="item" :projectData="approval_data"  :ref="'approval'+item.key_name"  v-model='approval_data[item.key_name]'> </v-text> -->
            <!-- <uc_editor v-if="item.type=='text'"  :moduel="item" :projectData.sync="approval_data" v-model='approval_data[item.key_name]' :ref="'approval'+item.key_name">
            </uc_editor> -->
            <v-text v-if="item.type=='text'"  :moduel="item" :projectData.sync="approval_data" v-model='approval_data[item.key_name]' :ref="'approval'+item.key_name" type='audit'></v-text>
            <div v-if="item.key_name=='document_ids'">
              <v-filelist_multiple :moduel="item" :projectData.sync ="approval_data" :input_callback="set_filelist" ref="approvalfiles" type='audit'></v-filelist_multiple>
            </div>
         </div>
       </div>
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAdd_approval = false">取 消</el-button>
          <el-button type="primary" @click="add_approval">创建审批</el-button>
          <div style="color: red;text-align: right">
            {{tips_approval}}
          </div>
       </span>
     </el-dialog>

    <!--设置关键字-->
    <el-dialog
      title="修改文档关键字"
      :visible.sync="DialogVisible_keyword"
      width="30%"
      center>
      <div class="keyword_setting">
       <el-input placeholder="请输入关键字" v-model="document_keyword">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="setKeywords_submit">提交</el-button>
        </span>
    </el-dialog>

     <!--查看项目描述-->
     <el-dialog :visible.sync="descriptionVisible">
       <div style="color: #0b509d;font-size: 16px;">
           <div style="border-bottom: 1px solid #dbdbdb;padding-bottom: 16px;font-size: 18px;">{{projectNum_Name}}</div>
       </div>
       <div style="margin-top: -10px;">
          <div  style="color: black;font-size: 18px;padding: 15px 0;">项目描述:</div>
         <div v-html="project_dataInit.description" :style="' max-height:'+ (height - 400) +'px;overflow: auto'"></div>
       </div>
       <!--<div slot="footer" class="dialog-footer">-->
         <!--<el-button @click="descriptionVisible = false"  type="primary">关闭</el-button>-->
       <!--</div>-->
     </el-dialog>
   </div>
</template>

<style type="text/css" scoped>
.right_container .default_page {
     font-size: 24px;
     color: #00499a;
     text-align: center;
     background: #fff;
     position: absolute;
     width: 100%;
}
.downloadTips {
    font-size: 12px;
    text-align: center;
    margin-top: 20px;
    line-height: 22px;
}
.approval {
    overflow: auto;
}
.updateTxt{
   color: red;
  cursor: pointer;
}
.ql-toolbar.ql-snow {
  line-height: 20px!important;
}
.project_btn{
   width: 96px!important;
}
.desc_content{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  position: relative;
    /*float: left;*/
}
.desc_content:hover::after {
  content: attr(data-title);
  display: inline-block;
  padding: 5px;
  border: 1px solid #ddd;
  position: relative;
  top: 0;
  left: 0;
}
.warpper_update{
    position: absolute;
    top: 0;
    right: 0;
}
.ellipsis{
   width: 70px;
   position: absolute;
   bottom: 0;
   right: 0;
  background: #f2f2f2;
  z-index: 99;
  text-align: right;
  line-height: 20px;
  color: #00499a;
}
.downloadTips img{
    width: 80%;
    margin-top: 10px;
}
.detail li{
    list-style: disc;
    width: 100%;
    /* white-space: normal;  */
}
.upload-demo {
   display: inline-block;
}
.desc_detail{
  /*overflow: hidden;*/
  /*height: 110px;*/
  /*text-overflow: ellipsis;*/
  /*word-break: break-all;*/
  /*display: -webkit-box;*/
  /*-webkit-box-orient: vertical;*/
  /*-webkit-line-clamp: 3;*/
  overflow: hidden;
  height: 130px;
  position: relative;
  padding-bottom: 20px;
  box-sizing: border-box;
}
/*.desc_detail p, .desc_detail div, .desc_detail li{*/
  /*display: -webkit-box;*/
  /*-webkit-box-orient: vertical;*/
  /*-webkit-line-clamp: 3;*/
  /*overflow: hidden;*/
  /*!*height: 110px;*!*/
  /*text-overflow: ellipsis;*/
/*}*/
.btn {
    height: 24px;
    line-height: 24px;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    background: #ccc;
    display: inline-block;
    text-align: center;
    border-radius: 5px;
    padding: 0 15px;
    margin:0 30px;
}
.comfirm_btn {
    background: #169bd5;
}
.scroll_div{
   height: 90%;
  overflow: auto;
}
.template_title{
    text-align: right;
    display: inline-block;
}
.template_wrapper{
    line-height: 40px;
    font-size: 14px;
}
.template_wrapper .el-input{
   width: 60%!important;
}
.auto_saved{
    color: #1454a5;
}
.create_project{
    font-size: 16px;
    font-weight: bold;
    text-align: center!important;
    /*text-indent: 2em;*/
}
.keyword_setting .el-input{
   width: 100%!important;
}
.right_container{
     margin-left: 10px;
     height: 100%;
     background: #fff;
     position: relative;
}
.detail_wrapper{
  background: #fff;
  padding: 5px 10px;
  font-size: 14px
}
.project_item{
   border: 1px solid #999999;
   background: #fff;
   overflow: hidden;
   text-overflow: ellipsis;
   padding:0 5px;
  position: relative;
}
   .selectType {
    width: 95%;
    line-height: 28px;
    height: 24px;
    cursor: pointer;
    font-family: 黑体;
    font-size: 12px;
    display: inline-block;
    padding-left: 5px;
    border-radius: 3px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(240, 240, 240);
    border-image: initial;
  }
  .add_file{
    width: 35px;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
    font-size: 10px;
    margin: 0 20px 0 0;
    line-height: 18px;
    cursor: pointer;
  }
  .bar{
    line-height: 40px;
    background: #eee;
    overflow:hidden;
    text-align: left;
  }
  .bar_right{
    position: absolute;
    top: 0;
    width: 100%;
  }
  .el-menu{
     background: transparent
  }
  .el-aside:nth-of-type(1) .el-menu {
     /*position: absolute;*/
     /*top: 50%;*/
    /*transform: translateY(-50%);*/
     /*padding-top: 100px;*/
  }
  .sysstemInfo{
      padding-top: 80px;
  }
  .el-aside:nth-of-type(2)  .el-menu{
    position: relative;
    /*top: 50%;*/
    /*transform: translateY(-50%);*/
    /*padding: 135px 0 0 0!important;*/
    height: 100%;
  }
   .el-aside:nth-of-type(2) .el-input {
      width: 100%!important;
   }
  .menu_top{
    /*top:0;*/
    /*position: fixed;*/
    /*z-index: 99;*/
    /*background: #fff;*/
    /*left: 110px;*/
  }
  .document_wrapper{
      width: 95%;
      overflow: hidden;
      border: 1px solid #aaa;
      margin:10px 0;
     padding: 5px;
     line-height: 26px;
  }
  .document_wrapper .document_info{
      display: inline-block;
  }
  .document_wrapper .document_detail{
    /* width: 300px; */
    float: right;
    position: relative;
  }
  .document_list{
      background: #e6e6e6!important;
  }
  .add_file  .el-button {
      vertical-align: bottom!important;
  }
  /*.add_file  .item {*/
      /*display: inline-block;*/
      /**/
  /*}*/
  .add_file img{
      height: auto;
      width: 22px;
      margin: 0  10px;
      vertical-align: middle;
  }
  .el-aside:nth-of-type(1){
     z-index: 99;
  }
  .el-aside:nth-of-type(2){
      left: 100px;
      padding: 0 10px;
  }
  .el-tag{
      margin: 8px !important;
  }
  .bottom_wrapper{
    padding-bottom: 20px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  /*.messageType{*/
    /*width: 70px;text-align: center;border: #8c939d 1px  solid;*/
    /*margin-left: 10px;*/
  /*}*/
  .newsContent .el-input {
    width: 500px!important;
  }
  .fr{
    float: right;
  }
  .fl{
    float: left;
  }
  .keyword{
      color: #0099ff;
  }
  .project_user_wrapper {
      display: inline-block;
  }
  .project_user_wrapper .el-select {
      width: 700px!important;
  }
  .el-tag{
      margin: 0 10px;
  }
  .right-bar {
      width: 600px;
  }
  .right-bar .item, .left-bar .item{
       display: inline-block;
       width: 25%;
       cursor: pointer;
       text-align: center;
       font-size: 14px;
  }
  .el-submenu__title i{
    color: #fff!important;
  }
  .el-submenu__title i{
    color:  #0093fd!important;
  }
  .el-submenu .el-submenu__title {
    text-align: center;
    line-height: 22px!important;
    height: auto!important;
  }
  .el-main{
    min-width:1200px;
    padding: 40px 0 0 370px!important;
    /*height: 800px;*/
  }
  /*.el-submenu__title i;:before {*/

    /*color:  #0093fd!important;*/
  /*}*/
  .el-icon-arrow-down:before{
     content: ''!important;
  }
  .el-submenu__title {
    line-height: 22px!important;
    padding: 0!important;
    /*height: 35px!important;*/
  }
  .project_selected{
    background: #fff;
    border: 1px solid #0095f5 ;
  }
  .project_name{
      color: #00499a;
      font-size: 17px;
      font-family: "微软雅黑";
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .icon_update{
      line-height: 18px;
      border: 1px solid red;
      border-radius: 12px;
      color: red;
      font-size: 12px;
      display: inline-block;
      padding: 0 6px;
      margin-left: 10px;
  }
  .content_show {
     border-width: 1px;
     border-style:solid solid solid solid;
     border-color:#0095f5 ;
    margin-top: -1px;
  }
  .item{
    width: 100%;
  }
     .plan_wrapper {
         display: block!important;
     }
    .textare {
        width:100%;
    }
    .moduel_input{
        display:inline-block;
        margin:5px;
    }
  #searchPage{
    width:100%;
    padding-top:108px;
    position:relative;
  }
  .el-aside{
    height:100%;
    background:#fff;
    /*border-right: 1px solid #ccc;*/
  }
  .bar{
    line-height: 40px;
    /*background: #eee;*/
    width: 100%;
   }
  .searchBar {
         width:80%;
  }
  .selectType {
    width: 200px;
    line-height: 28px;
    height: 24px;
    cursor: pointer;
    font-family: "微软雅黑";
    font-size: 12px;
    display: inline-block;
    padding-left: 5px;
    border-radius: 3px;
    border: 1px solid #dbdbdb;
    color:#333;
    }
  .header {
      position: fixed;
      top: 0;
      left: 50%;
      margin-left:-650px;
      width:1300px;
      background:#fff;
  }
  .mint-searchbar{
    background: #0099ff!important;
  }
  .mint-searchbar-cancel{
      color: #fff!important;
  }
  .mint-cell:last-child{
     background-image: transparent!important;
  }
  .mint-cell-wrapper {
    background-image: transparent!important;
  }
  .mint-search{
     height: auto!important;
     display: inline-block;
     width: 80%;
  }
  .result_header{
      /*line-height: 35px;*/
  }
  .name{
      font-weight: bold;
  }
  .company_status{
    border: 1px solid #34cc33;
    line-height: 24px;
    font-size: 12px;
    padding: 0 10px;
    color: #34cc33;
  }
   .infoWrapper{
        color:#999;
    }
    .info{
        display: inline-block;
        margin:0 10px;
    }
    .representative{
        color:#0084ff;
    }
    .searchType{
        padding: 0 15px;
        cursor: pointer;

    }
    .searchTypeSelected {
        color:#fff;
        background: #0099ff;
    }
    /*.el-button{*/
        /*vertical-align: top!important;*/
    /*}*/
    .mint-search-list{
        left:-999999!important;
        right:auto!important;
    }
    .typeSelected{
      background: #0093fd!important;
      color: #fff !important;
    }
    .lists a {
        color:#333;
       text-decoration: none;
       border-bottom: 1px solid #ccc;
      padding: 10px 0;
      display: block;
    }
    .lists a:nth-last-child(1) {
       border-bottom: none;
    }
    .el-pagination {
        text-align: center;
    }
  .bottom_wrapper{
    padding-bottom: 20px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .newsContent .el-input {
    width: 500px!important;

  }
  .bottom_bar{
    position: fixed;
    top: 50px;
    width: 50%;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);

  }
  .el-main{
    min-width: 1100px;
  }
  .el-main:nth-of-type(2){
    max-height: 800px;
  }
  .bottom_bar .el-input__inner {
    width: 400px;
  }
  .newsWapper{
    /*width: 70%;*/
    /*margin:20px auto 0;*/
    /*height: 87%;*/
    min-width: 400px;
    /*position: relative;*/
    /*padding-bottom: 60px;*/
    overflow: auto;
    /* max-height:600px; */
  }
  .right-box{
    text-align: right;
  }
  .message-box{
    line-height: 30px;
    margin: 10px 0;
  }
  .items {
    margin:0 15px;
  }
  .speech-bubble {
    position: relative;
    background-color:#e5e5e5;
    height: auto;
    line-height: 30px; /* 垂直居中 */
    color:#000;
    text-align: left;
    font-family: sans-serif;
    display: inline-block;
    vertical-align: top;
    padding-right: 15px;
    word-break: break-all;
    box-shadow:3px 0 1px #e5e5e5 inset;
    max-width: 400px;
  }
  .speech-bubble-right{
    margin:10px 35px 0 0 ;
  }
  .speech-bubble-left{
    margin: 10px 0  0  35px;
  }
  .speech-bubble:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: 15px solid;
    color: #fff;
  }
  .vistor {
    line-height: 24px;
  }
  .vist_info {
    height: 100px;
    width: 128px;
    padding: 10px 0;
    color: #fff100;
    line-height: 22px;
    z-index: 999;
    position: relative;
    font-size: 15px;
  }
  .blnk_bg {
    height: 100%;
    width: 120px;
    background: #000;
    /* older safari/Chrome browsers */
    -webkit-opacity: 0.5;
    /* Netscape and Older than Firefox 0.9 */
    -moz-opacity: 0.5;
    /* Safari 1.x (pre WebKit!) 老式khtml内核的Safari浏览器*/
    -khtml-opacity: 0.5;
    /* IE9 + etc...modern browsers */
    opacity: .5;
    /* IE 4-9 */
    filter:alpha(opacity=50);
    /*This works in IE 8 & 9 too*/
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
    /*IE4-IE9*/
    filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);
    z-index: -1;
    position: absolute;
    left:0;
    top: 0;
  }
  .sxry {
    margin-bottom: 10px;
  }
  .el-header {
    position: fixed;
    z-index:4;
    top: 0;
    width: 100%;
    background: #fff;
  }
  .sidebar_r {
    color: #40404a;
    font-size: 14px;
    width: 70%;
    font-weight: bold;
    line-height: 22px;
  }
  .sidebar_r_top {
    padding-left: 20px;
    border-bottom: 1px solid #dddddd;
  }
  .sidebar_r_bottom {
    padding: 5px 5px 5px 20px;
  }
  .brand {
    margin-right: 60px;
    font-size: 16px;
    line-height: 26px;
    height: 26px;
  }
  .project_detail{
    overflow: hidden;
     /*border: 1px solid #666;*/
    /* width: 95%; */
     /* margin: 5px auto; */
    /* font-size: 12px; */
    background:#f2f2f2;
    /* line-height: 24px; */
    white-space: normal;
    color:#000;
  }
  .other_detail .detail{
    /*width: 240px;*/
    /* word-break: break-all; */
    overflow: hidden;
    text-overflow: ellipsis;
    /* white-space: normal!important; */
  }
  .brand img{
    height: 26px;
    width: auto;
    vertical-align: middle;
    margin-left: 3px;
  }

  .client_info, .vist_target_content {
    margin-bottom: 3px;
  }
  .client_info {
    overflow: hidden;
  }
  .vist_target, .staff, .cooperative_company {
    font-family: '微软雅黑';
    font-weight: normal;
  }
  .statVisitCount{
    color: #93c025!important;
    text-decoration: none;
    border-bottom: 1px solid #93c025;
  }
  .el-container{
     /*height: ;*/
  }
  .assocCount{
    color: #091ed9!important;
    text-decoration: none;
    border-bottom: 1px solid #091ed9;
  }
  .visitContent{
    font-family: '微软雅黑';
    font-weight: normal;
    height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    white-space:nowrap;
    width: 80%;
  }
  .vist_target {
    height: auto;
  }
  .warm_tips{
    display: inline-block;
    margin-left: 10px;
  }
  .vist_detail {
    /*width: 70%;*/
    line-height: 30px;
  }
  .details {
    margin-right: 5px;
    display: inline-block;
    vertical-align: top;
  }
  .txt {
    vertical-align: top;
  }
  .list {
    padding: 10px;
    overflow: hidden;
  }
  .container .list {
    min-width: 770px;
  }
  .list:nth-of-type(odd) {
    background: #eeeeee;
    border: 1px solid #eeeeee;
  }
  .list:nth-of-type(even) {
    background: #fff;
    border: 1px solid #ccc;
  }
  .del {
    padding: 0  10px  0 30px;
    border-left: 1px solid #d3d3d3;
    border-right: 1px solid #d3d3d3;
    line-height: 26px;
    display: inline-block;
    color: #b5b5b5;
    /*background: url(../../img/pc/del.png) no-repeat 10px center;*/
    background-size: 16px auto;
  }
  .del:hover {
    color: red;
    /*background: url(../../img/pc/del_selected.png) no-repeat 10px center;*/
  }
  .del img {
    height: 16px;
    width: auto;
    vertical-align: middle;
    margin: 0;
    cursor: pointer;
  }
  .category_btn{
    background: #ccc;
    line-height: 28px;
    height: 28px;
    border-radius: 3px;
    display: inline-block;
    margin:8px 15px;
    padding: 0 5px;
    cursor: pointer;
    font-family: '微软雅黑';
  }
   .search_selected {
     background: #01cdff;
     color: #fff;
  }
  .selected_btn{
      color: #0098fe;
      color: #fff;
  }
  .menu_top .category_btn{
     margin: 5px 10px 5px 0;
  }
  .detail_wrapper .category_btn{
     margin:0;
     line-height: 22px;
     height: 22px;
     margin-right: 15px;
  }
  .systemInfo{
      padding-top: 10px;
      text-align: center;
      color: #fff;
  }
  .systemInfo .category_btn{
    line-height: 28px;
    margin:8px;
    width: 60px;
    /*border: 1px solid #ccc;*/
    background:transparent;
  }
  .systemInfo .typeSelected{
       background:#4589c8!important;
  }
  /*.recorder_list {*/
    /*margin-top: 15px;*/
    /*height: 96%;*/
    /*overflow: auto;*/
    /*!*min-width:780px;*!*/
    /*width: 98%;*/
  /*}*/
  .sidebar_l {
    border: 1px solid #999;
    height: 120px;
    overflow: hidden;
    width: 200px;
    position: relative;
    margin-right: 15px;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: cover;
  }
  .function_btn{
     width: 80px;
     display: inline-block;vertical-align: top;cursor: pointer;
     text-align: center;
  }
  .loginout {
    color:#0099ff;
  }
  .item{
    text-decoration: none;
    margin-right: 30px;
    line-height: 35px;
    cursor: pointer;
    text-align: right;
  }
  .del_txt {
    border-bottom: 1px solid #d3d3d3;
    padding-bottom: 1px;
    font-weight: normal;
    cursor: pointer;
  }
  .number {
    color: #0093fd;
    font-weight: normal;
  }
  .main-left, .main-right {
    position: absolute;
    /*min-height: 760px;*/
  }
  .main-left {
    top: 0px;
    left: 0;
    background: #e7e7e7;
    width: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
  }
  .main-right {
    width: 180px;
    top: 30px;
    right: 0;
    height: 770px;
    border: 1px solid #dbdbdb;
    padding: 20px 0 0 10px;
    color: #098ff2;
    font-size: 14px;
  }
    @keyframes gogo
    {
      from {margin-left:-200px}
      to {margin-left:-200px}
    }

    @-webkit-keyframes gogo /* Safari 与 Chrome */
    {
      from {background: red;}
      to {background: yellow;}
    }
</style>

<script>

// // import header from '../components/header.vue';
// // import menu from '../components/menu.vue';
// // import projecttemplate from '../components/project-template.vue';
// import inputs from '../components/c-input.vue';
// import datepicker from '../components/TimePicker.vue';
// import selects from '../components/c-select.vue';
// // import next_plan from '../components/next_plan.vue';
// import selectObj from '../components/selectObj_user.vue';
// import texts from '../components/c-text.vue';
// import select_flow from '../components/select_flow.vue';
// import selectFile from '../components/filelist.vue';
// import selectFile_multiple from '../components/filelist_multiple.vue';
// import audit from '../components/audit.vue';
// import editor from '../components/editor.vue' ;
// import uc_editor from '../components/ue_editor';
// // import store from '../vuex/store.js';

export default {
  name:'',
  data(){
    return {
      bar_height:40,
      btn_height:54,
      side2_menu_height: 160,
      side3_top:35,
      dialogAdd_approval:false,
       message:'',
       search_word:'',
        project_name:'',
       projectNum_Name:'',
        page:'project',
        activeName: 'first',
        user_info:{},
        options:['a','b','c'],
        checkList: [],
        more_data_text:'',
        show_customer:false,
        show_city:false,
        visit_list:{list:[]},
        limits:10,
        currentPage:1,
        Number:20,
        init_list:true,
        role:'',
        project_tips:'',
        timer:'',
        pageSize:10,
        addUser_tips:'',
        has_more:true,
        citys:[],
        customer_ids:[],
        project_user_add:[],
        city:'',
        messagLists:[],
        dialogVisible: false,
        templates:[],
        // message_types:[{value:0,lable:'全部消息'},{value:1,lable:'普通消息'},{value:2,lable:'文档'},{value:3,lable:'审批消息'}],
        message_types:[{value:2,lable:'文档'},{value:3,lable:'审批消息'}],
        selected:'document_selected',
        fresh:true,
        project_data:{},
        user_selected:[],
        user_selected_str:'',
        leader_user_ids:[],
        web_token:'',
        projectsList:{list:[],count:''},
        add_user:[],
        document_count:'',
        user_list:[],
        project_user_list:[],
        project_user_list_arr:[],
        project_id:'',
        templates_approval:[],
        approval_data:{},
         content:'',
         name:'',
         tips_delDocument:'',
         fileList3:[],
         document_ids:[],
         documentsList:[],
         message_type:3,
         dialogAdd_document:false,
         dialogAdd_document2:false,
         document_data:{},
         limit:1,
         get_type:0,
         files:[],
         tips_approval:'',
         tips_document2:'',
         tips_document:'',
         delDocument_name:'',
         delDocument_id:'',
         editDocument_id:'',
         editDocument_index:'',
         done:false,
         init_list:false,
         fileList_document_edit:[],
          is_join:false,
          is_leader:false,
          is_manage:true,
          total:false,
         documents_total:[],
         document_keyword:'',
         DialogVisible_keyword:false,
        edit_list_index:-1,
        edit_url:'',
        infoForm: {
            a_title: '',
            a_source: '',
            a_content:'',
            editorOption: {}
          },
      project_dataInit:{description:'',customer_ids:[],keyword:''},
      upload_url:'',
      upload_url_edit:'',
      project_list_index:0,
      edit_projectData:{},
      projectNum:'',
      function_type:1,
      upload_file_data_edit:{},
      upload_file_data_approval:{},
      DialogVisible_tips:false,
      DialogVisible_tips_add:false,
      lists:{list:[],count:0},
      order_by_params:[],
      sort_params:[],
      customers:[],
      fileList_edit:[],
      fileList_approval:[],
      createTime:'',
      files_total:[],
      typeSelected_add_project:false,
      typeSelected_edit_project:false,
      upload_file_data:{keyword:''},
      appUrl:'',
      description:'',
      project_index:0,
      // show_ellipsis:false,
      description_high:0,
      project_update_count:0,
      auto_saved:false,
      hide_save:false,
      descriptionVisible:false,
      sort:[{value:1,lable:'倒序'},{value:2,lable:'正序'}],
      show_save:false,
      auto_text:'',
      visit_log:[],
      desc_update:false,
      end_time_update:false,
      user_update:false,
      project_user_update:'',
      documents_update:false,
      is_update:false,
      web_url:'',
      projectsItemShow:[],
      data_ok:false,
      order_by:[{value:'name',lable:'名称'},{value:'status',lable:'状态'},{value:'create_time',lable:'创建时间'}],
      getDataParam:{page:1,limits:10,my_approval:true,my_create:true,underway:true,is_finish:true,is_failure:true,is_correct:true,is_abend:true,order_by:'',sort:''}
    }
  },
  props:["height", "width"],
  // store,
  methods:{
    backToLogin(){
      this.$router.push('/login');
    },
    set_filelist(_content){
        this.approval_data.document_ids = _content;
    },
    set_add_project_input(){

    },
    //获取审批模板
    getTemplate_approval:function(){
        this.$http.post(this.web_url+'/project/vue_template',{web_token:this.web_token,system:'web',model_id:7},{emulateJSON:true}).then(function(res){
            // console.log(this.templates);
            if(res.data.status == 'ok'){
                 this.templates_approval = res.data.data;
                  this.resetparem_approval();
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }

          })
        .catch(function(res1){
          console.log(res1);
        });
    },
    //获取模板 添加项目
    getTemplate:function(){
      this.$http.post(this.web_url+'/project/vue_template',{web_token:this.web_token,system:'web'},{emulateJSON:true}).then(function(res){
        // console.log(this.templates);
        if(res.data.status == 'ok'){
          this.templates = res.data.data;
          this.resetparem_project_add();
        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }

      })
        .catch(function(res1){
          console.log(res1);
        });
     },
    checkParams(data){
         var is_ok = true;
         for(var i=0; i< this.templates.length; i++) {
          if(this.templates[i].required){
            if(data[this.templates[i].key_name] == '' || data[this.templates[i].key_name] == []){
                    is_ok = false;
                    return is_ok;
              }
            }
          }
          return is_ok;
    },
    //默认隐藏保存按钮
    hide_auto_save(){
        this.show_save = false;
    },
    // 检测必填数据
    check_project_data(type, _call_back){
      if(type == 'add'){
        var can_sunbmit = this.checkParams(this.project_data);
        if(can_sunbmit){
          this.typeSelected_add_project = true;
        }else {
           this.typeSelected_add_project = false;
        }
      }
      if(type == 'edit'){
         this.edit_project('auto', _call_back);
        // var can_sunbmit = this.checkParams(this.edit_projectData);
        // if(can_sunbmit){
        //   this.typeSelected_edit_project = true;
        // }else {
        //    this.typeSelected_edit_project = false;
        // }
      }
    },
    // 初始化编辑项目的值
    init_projectData(){
        for(var i=0; i< this.templates.length; i++) {
            this.edit_projectData[this.templates[i].key_name] = this.project_dataInit[this.templates[i].key_name];
            if(this.templates[i].key_name == 'join_user_ids' || this.templates[i].key_name  == 'leader_user_ids' || this.templates[i].key_name == 'manage_user_ids'){
               var item = this.project_dataInit.project_user;
               var users = [];
               for(var a=0; a< item.length; a++) {
                 if(item[a].key_name == this.templates[i].key_name){
                     var user = {user_id:item[a].user_id,username:item[a].username}
                     users.push(user);
                 }
               }
               this.edit_projectData[this.templates[i].key_name] = users;
            }else if(this.templates[i].key_name == 'customer_ids'){
                var item = this.project_dataInit.customer_ids;
                var customers  = [];
                for(var a=0; a< item.length; a++) {
                    var customer = {khmc:item[a].khmc,khdm:item[a].khdm,clientlevel:item[a].clientlevel,khjc:item[a].khjc}
                    customers.push(customer);
                }
                this.edit_projectData[this.templates[i].key_name] = customers;
            }else if(this.templates[i].type == 'select' && this.project_dataInit[this.templates[i].key_name] != null  && this.project_dataInit[this.templates[i].key_name] != ''){
               this.edit_projectData[this.templates[i].key_name] = this.project_dataInit[this.templates[i].key_name].id;
            }
        }
    },
    // 编辑项目
    edit_project(edit_type, _call_back){
        this.edit_projectData.web_token = this.web_token;
        console.log("save", this.edit_projectData.description_high,);
        this.$http.post(this.web_url+'/project/'+this.project_id+'/edit',this.edit_projectData,{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
                this.project_detail(this.project_id,'edit');
                this.get_viist(this.project_id);
                // this.function_type = 1;
                 if(edit_type == 'auto'){
                     this.auto_text = '保存成功！';
                     this.auto_saved = true;
                   this.show_save = false;
                     var _this = this;
                     setTimeout(function () {
                       _this.auto_saved = false;
                       _this.auto_text = '';
                     },3000);
                 }else if(edit_type == 'btn_save'){
                     var _this = this;
                     clearInterval(this.timer);
                     this.project_tips = '修改成功';
                     this.timer = setInterval(function(){
                       _this.project_tips =  '';
                     },2000);
                     this.show_save = false;
                 }
                //清空选项中的数据
                // for(var i=0; i< this.templates.length; i++) {
                //   var ref = 'project_edit'+this.templates[i].key_name;
                //   this.$refs[ref][0].clear();
                // }
                 // 刷新页面
                 // this.$router.push({path:'/blank/'+this.project_id,query:{id:this.project_id,type:'project'} })
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }else {
              this.edit_tips( res.data.message);
              this.show_save = false;
              // var _this = this;
              //  clearInterval(this.timer);
              //  this.project_tips =  res.data.message;
              //  this.timer = setInterval(function(){
              //     _this.project_tips =  '';
              //  },2000);
            }
            if(typeof(_call_back) === "function"){
              _call_back();
            }
          })
        .catch(function(res1){
          var _this = this;
          clearInterval(this.timer);
          this.project_tips = '网络出错';
          this.timer = setInterval(function(){
            _this.project_tips =  '';
          },2000);
        });
    },
    //添加项目
    create_project(){
        this.project_data.web_token = this.web_token;
        this.$http.post(this.web_url+'/project/add',this.project_data,{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
                // 成功创建项目后，显示所有项目，且选中刚创建的项目。
                this.is_leader = false;
                this.is_update = false;
                this.search_word = '';
                this.getData('add');
                this.resetparem_project_add();
                this.project_tips =  '';

                //清空创建项目中的数据
                for(var i=0; i< this.templates.length; i++) {
                  var ref = 'project'+this.templates[i].key_name;
                  this.$refs[ref][0].clear();
                }
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }else {
              var _this = this;
               clearInterval(this.timer);
               this.project_tips = res.data.message;
               this.timer = setInterval(function(){
                  _this.project_tips =  '';
               },2000);
            }
          })
        .catch(function(res1){
          console.log(res1);
        });
    },
    // 添加项目 按钮点击
    add_project(){
      if(this.function_type === 3) return false;
      if(this.function_type == 4){
           var _this = this;
           _this.editors_clear("project_edit");
           this.function_type = '';
           this.typeSelected_add_project = false;
          //  重新调用 mouted
            setTimeout(function() {
              _this.project_data.leader_user_ids = [];
              sessionStorage.setItem('add_leader_user','Y');
              _this.function_type = 3;
              _this.project_id = '';
            }, 100);
        // this.$confirm('正在编辑项目，离开会丢失录入的内容，是否确定离开？', '提示', {
        //   cancelButtonText: '继续编辑',
        //   confirmButtonText: '确定离开',
        //   type: 'warning'
        // }).then(() => {
        //    var _this = this;
        //    _this.editors_clear("project_edit");
        //    this.function_type = '';
        //    this.typeSelected_add_project = false;
        //   //  重新调用 mouted
        //     setTimeout(function() {
        //       _this.project_data.leader_user_ids = [];
        //       sessionStorage.setItem('add_leader_user','Y');
        //       _this.function_type = 3;
        //       _this.project_id = '';
        //     }, 100);
        // }).catch(() => {

        // });
      }else {
        sessionStorage.setItem('add_leader_user','Y');
        //TODO: 切换项目
        this.function_type = 3;
        this.project_id = '';
      }
    },
    // 人员改变 项目角色不能重复
    user_change_parent(type){
      // var project_type = type == 'add'? 'project':'project_edit';
      var user_role = ['leader_user_ids','manage_user_ids','join_user_ids'];
      // for(var i=0; i< this.templates.length; i++) {
      //   if(user_role.indexOf(this.templates[i].key_name) > -1){
      //       var ref = project_type+this.templates[i].key_name;
      //       if(ref in this.$refs){
      //           this.$refs[ref][0].user_change();
      //       }
      //   }
      // }
      if(type == 'add'){
        for(var i=0; i< this.templates.length; i++) {
          if(user_role.indexOf(this.templates[i].key_name) > -1){
              var ref = 'project'+this.templates[i].key_name;
              if(ref in this.$refs){
                  this.$refs[ref][0].user_change();
              }
          }
        }
      }

      if(type == 'edit'){
        for(var i=0; i< this.templates.length; i++) {
          if(user_role.indexOf(this.templates[i].key_name) > -1){
              var ref = 'project_edit'+this.templates[i].key_name;
              if(ref in this.$refs){
                this.$refs[ref][0].user_change();
              }
          }
        }
        this.edit_project('auto');
      }
    },
    editors_clear: function(name){
      for(var i=0; i< this.templates.length; i++) {
        var ref = name +this.templates[i].key_name;
        if(ref in this.$refs){
          this.$refs[ref][0].clear();
        }
      }
    },
    //重置参数 添加项目
    resetparem_project_add(){
      for(var i=0; i< this.templates.length; i++) {
        this.project_data[this.templates[i].key_name] = '';
        if(this.templates[i].type ==  'select_by_api'){
          this.project_data[this.templates[i].key_name] = [];
        }
      }
    },
    //重置参数 编辑项目
    resetparem_project_edit(){
      for(var i=0; i< this.templates.length; i++) {
        this.edit_projectData[this.templates[i].key_name] = '';
        if(this.templates[i].type ==  'select_by_api'){
          this.edit_projectData[this.templates[i].key_name] = [];
        }
      }
    },
    // 设置关键字
    setKeywords(keyword,id,index){
       var str = keyword == '' || keyword == null ?  '设置关键字' : '修改关键字';
        this.$prompt('请输入关键字', str, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue:keyword
        }).then(({ value }) => {
          this.$http.post(this.web_url+'/document/'+id+'/edit',{web_token:this.web_token, keyword:value},{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
                this.documents_total[index].keyword = value;
                this.DialogVisible_keyword = false;
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }
          })
          .catch(function(res1){
            console.log(res1);
          });
        }).catch(() => {

        });
      //  this.document_keyword = keyword;
      //  this.DialogVisible_keyword = true;
      //  this.editDocument_id = id;
      //  this.editDocument_index = index;
    },
     // 设置关键字
    setKeywords_submit(){
        this.$http.post(this.web_url+'/document/'+this.editDocument_id+'/edit',{web_token:this.web_token, keyword:this.document_keyword},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
            this.documents_total[this.editDocument_index].keyword = this.document_keyword;
            this.DialogVisible_keyword = false;
        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }
      })
      .catch(function(res1){
        console.log(res1);
      });
    },
    // 更新文档
    file_edit(id){
        this.upload_url_edit = this.web_url+'/document/'+id+'/edit';
        this.upload_file_data_edit.web_token = this.web_token;
    },
    handleSuccess_edit(res){
       this.fileList_edit = [];
       this.getDocuments(this.project_id);
    },
    handleChange_approval(file, fileList) {
      // var ref = 'document2file_id';
      // this.document_data2.file_id = '';
      // this.$refs[ref][0].clear();
    },
    // 文档成功上传 审批
    handleSuccess_approval(res){
      this.documentsList.push(res.data);
      this.files.push(res.data);
      this.$refs.upload_approval[0].clearFiles();
      this.fileList_approval = [];
      //  this.getDocuments(this.project_id);
    },
    // 文档成功上传 审批
    handleSuccess2(res){
      //  this.fileList_approval = [];
      //  this.getDocuments(this.project_id);
    },
    //获取项目所有的文档
    getDocuments(id){
      this.$http.post(this.web_url+'/document',{web_token:this.web_token,limits:10000,project_id:id},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          this.documents_total = res.data.data.list;
           this.function_type = 2;
        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }
      })
      .catch(function(res1){
        // console.log(res1);
      });
    },
    //获取附件所有的文档
    getDocuments_all(){
      this.$http.post(this.web_url+'/document',{web_token:this.web_token,my_create:true,limits:10000},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
           this.files_total = res.data.data.list;
        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }
      })
      .catch(function(res1){
        console.log(res1);
      });
    },
    //删除
    delDocumentFormTable(index,id){
      this.documentsList.splice(index,1);
      var ref = 'approvalfiles';

      //删除已选的文档
      // var index = -1;
      // for (var i =0; i < this.files.length; i++){
      //      if(this.files[i].id == id){
      //        this.files.splice(i, 1);
      //        index = 0;
      //      }
      // }
      // if (index ==  -1) {
      //   this.$refs[ref][0].del(id);
      // }

      this.$refs[ref][0].del(id);
    },
    download(url){
      window.open(url);
    },
     preview_video_tips() {
       const h = this.$createElement;
       this.$message({
         message: h('p', null, [
           h('span', null, '格式不支持,不能预览,仅可下载 '),
           h('i', { style: 'color:black '},'')
         ])
       });
       // this.$message('格式不支持,不能预览,仅可下载');
    },
    //预览
    preview(url,type){
      if(url.indexOf(".mp4") < 0 && type == 'MP4'){
        this.preview_video_tips();
        return ;
         // url = url.replace("/download/","/preview/");
      }
      let routeUrl = this.$router.resolve({
        path: "/preview",
        query: {url:url,type:type}
      });
      window.open(routeUrl .href, '_blank');
      // this.$router.push({path:'/preview',query:{item:item} })
    },
    //更新消息
    switch_page(message_type){
      // 审批
      if(message_type == 2){
        this.$router.push({path:'/main/project/welcome'})
      }
      this.message_type = message_type;
    },
    //删除文档
    delDocumentFormList(delDocument_id,delDocument_name,index){
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning',
          center: true
        }).then(() => {
          this.$http.post(this.web_url+'/document/'+delDocument_id+'/delete',{web_token:this.web_token},{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
              this.getDocuments(this.project_id);
              this.documents_total[index].del = 2;
              // this.documents();
            }else {

            }
          })
          .catch(function(res1){
            console.log(res1);
          });
        }).catch(() => {

        });

    },
    //菜单切换
    tab(name){
       this.selected = name;
    },
    //跳转审批页面
    approval_detail(id){
      let routeUrl = this.$router.resolve({
        path: "/approval_detail/"+id,
        query: {id:id}
      });
      window.open(routeUrl .href, '_blank');

      // this.$router.push({path:'/approval_detail/'+id,params:{id:id} });
    },
    //关联文档
    relative_documents(res){
      var documents = [];
      for(var i =0; this.files_total.length > i; i++){
        if( res.indexOf(this.files_total[i].id)>-1){
          documents.push(this.files_total[i]);
        }
      }
      this.documentsList = documents.concat(this.files);
    },
    //重置参数 添加审批
    resetparem_approval(){
      var arr = ['select_upload_file','select_flow','select_project_user']
      for(var i=0; i< this.templates_approval.length; i++) {
        if(arr.indexOf(this.templates_approval[i].type) > -1){
            this.approval_data[this.templates_approval[i].key_name] = [];
        }else {
           this.approval_data[this.templates_approval[i].key_name] = '';
        }
      }
      this.data_ok = true;
    },
    listenToChildFocus(){
       console.log(45)
    },
    //更新列表数据
    updateData(val){
      this.getDataParam.page = val;
      this.get_approval();
    },
    //获取审批
    get_approval:function(){
      this.getDataParam.web_token = this.web_token;
      this.$http.post(this.web_url+'/approval',this.getDataParam,{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          this.lists = res.data.data;
        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }
      })
        .catch(function(res1){
          console.log(res1);
        });
    },
    handleChange(file, fileList) {
      // var ref = 'documentfile_id';
      // this.document_data.file_id = '';
      // this.$refs[ref][0].clear();
    },
    handleSuccess(res){
      this.fileList3 =[];
      this.getDocuments(this.project_id);
    },
    //上传文档
    add_document() {
      this.document_data.web_token = this.web_token;
      this.document_data.project_id = this.project_id;
      if(this.document_data.file_id == ''){
        this.document_data.web_token = this.web_token;
        this.$refs.upload[0].submit();
      }else {
        this.add_file();
      }
    },
    //文档更新成功
    upload_document(res){
        this.getDocuments(this.project_id);
        this.$refs.upload_edit[0].clearFiles();
    },
    //获取项目列表
    getData:function(type){
        this.$http.post(this.web_url+'/project',{web_token:this.web_token,limits:1000,is_leader:this.is_leader,is_update:this.is_update},{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
                  // 首次进入页面 如果数据为0 不显示搜索框
                  if(res.data.data.list.length > 0){
                      this.init_list = true;
                  }
                  // if(this.done && res.data.data.project_update_count){
                  //     this.init_list = true;
                  // }
                  this.project_update_count =   res.data.data.project_update_count;
                  this.projectsList = res.data.data;
                  this.done = true;
            

                if(type == 'add' && this.projectsList.list.length > 0){
                    this.function_type = '';
                    // this.detail(this.projectsList.list[0].id);
                    this.show_project_detail(this.projectsList.list[0].id,0);
                }else {
                   this.function_type = 1;
                   this.project_id = '';
                }
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }
          })
        .catch(function(res1){
          console.log(res1);
        });
    },
    //选择项目人员
    add_user_selected(names){
       console.log(names);
    },
    getUsers:function(){
      this.$http.post(this.web_url+'/user_list',{web_token:this.web_token},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          this.user_list = res.data.data;
        }else {

        }
      })
      .catch(function(res1){
      });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },
    //退出登录
    loginout:function(){
      this.$http.post(this.web_url+'/logout',{web_token:this.web_token,system:'web',model_id:'6'},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          sessionStorage.removeItem("user_info");
          sessionStorage.removeItem("web_token");
          this.$router.push({path:'/login'});
        }else {

        }
      })
        .catch(function(res1){
          console.log(res1);
        });
    },
    //获取项目描述高度
    desc_height:function(){
       // var id = 'desc'+this.project_index;
       var desc = document.getElementById('desc');
       if(desc != null){
         var h = desc.offsetHeight; //高度
         this.edit_projectData.description_high = h;
         console.log(h)
         // if (h > 110) {
         //   this.show_ellipsis = true;
         // }else {
         //   this.show_ellipsis = false;
         // }
       }
    },
    //获取项目描述高度_添加
    desc_add_height:function(){
      // var id = 'desc'+this.project_index;
      var desc = document.getElementById('desc_add');
      if(desc != null){
        var h = desc.offsetHeight; //高度
        this.project_data.description_high = h;
        console.log(h)
        // if (h > 110) {
        //   this.show_ellipsis = true;
        // }else {
        //   this.show_ellipsis = false;
        // }
      }
    },
    //添加审批
    add_approval(){
      this.approval_data.document_ids = [];
      for (var i =0; i < this.documentsList.length;i++){
        this.approval_data.document_ids.push(this.documentsList[i].id);
      }
      var _this = this;
      this.approval_data.web_token = this.web_token;
      this.$http.post(this.web_url+'/approval/apply',this.approval_data,{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          this.get_approval();
          this.tips_approval =  '';
          this.dialogAdd_approval = false;

          //清空选项中的数据
          for(var i=0; i< this.templates_approval.length; i++) {
            var ref = 'approval'+this.templates_approval[i].key_name;
            if(this.templates_approval[i].key_name != 'document_ids'){
              this.$refs[ref][0].clear();
            }
          }
          this.$refs.approvalfiles[0].clear();
          this.documentsList = [];
          this.files = [];
          this.resetparem_approval();

        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }else {
          _this.tips_approval = '请检查再提交，必填项不能为空';
          setTimeout(function () {
            _this.tips_approval =  '';
          },5000)
        }
      })
      .catch(function(res1){
        console.log(res1);
      });
    },
    //编辑 文档切换
    //获取拜访列表
    get_viist(id){
      this.$http.post(this.web_url+'/project/'+id+'/visit_log',{web_token:this.web_token,limits:10000},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
            this.visit_list = res.data.data;
        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }
      })
      .catch(function(res1){
        // console.log(res1);
      });
    },
    //获取项目详情
    project_detail(id,type){
      // this.selected= 'project_name';
      var _this = this;
      this.$http.post(this.web_url+'/project/'+id,{web_token:this.web_token},{emulateJSON:true}).then(function(res){

        if(res.data.status == 'ok'){
          this.visit_log =  res.data.data.visit_log;
          this.user_selected = [];
          this.leader_user_ids = [];
          this.project_dataInit =  res.data.data;
          this.project_name = res.data.data.name;
          this.customer_ids = res.data.data.customer_ids;
          this.project_id = id;
          this.projectNum =  res.data.data.project_num;
          this.description = (this.HTMLEncode(this.project_dataInit.description));
          this.project_user_list = this.project_dataInit.project_user;
          _this.project_user_list = res.data.data.project_user;
          this.projectsList.list[this.project_list_index].name = this.project_dataInit.name;
          this.projectsList.list[this.project_list_index].objective = this.project_dataInit.objective;

          this.get_change_staus();
          for(var i =0; this.project_user_list.length > i; i++){
             this.user_selected.push(this.project_user_list[i].username);
             if(this.project_user_list[i].key_name == 'leader_user_ids'){
                 this.leader_user_ids.push(this.project_user_list[i].user_id);
                 if(type == 'detail'){
                   this.function_type = 2;
                 }
             }
          }

          this.user_selected_str = this.user_selected.join(' ');
        }else if(res.data.status == 'error'){
          if(res.data.message == '没有权限！'){
              this.function_type = 1;
              this.getData('');
           }
        }else if(res.data.error_code == '401'){
          this.backToLogin();
        }
      })
      .catch(function(res1){
        // console.log(res1);
      });

      // var _this = this;
      // setTimeout(function () {
      //   _this.get_H();
      // },100)
    },
    //拜访详情
    visit_detail(visit_id){
        window.open('http://imosss.whadshel.com/test_crm/visit/web_detail/'+visit_id)
    },
    //筛选项目
    selecteProjectList(type){
      if(type == 'is_leader'){ 
           this.is_leader = !this.is_leader;
      }
      if(type == 'total'){
        // this.total = true;
        this.is_update = false; 
        this.is_leader = false;
      }
      // if(type == 'is_manage'){
      //   this.is_manage = !this.is_manage
      // }

      // if(!this.is_leader&&!this.is_join&&!this.is_manage){
      //   this.is_leader = !this.is_leader;
      //
      // }
      this.getData('');
    },
    HTMLEncode(html) {
        var temp = document.createElement("div");
        // temp.innerHTML = html
        (temp.textContent != null) ? (temp.innerHTML = html) : (temp.innerText = html);
        var output = temp.innerText ;
        temp = null;
        return output;
    },
    // 获取全部客户
    getCustomer:function(){
      this.$http.post(this.web_url+'/customer_list',{web_token:this.web_token,keyword:''},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          this.customers = res.data.data;
        }else {

        }
      })
      .catch(function(res1){
      });
    },
    //获取更新列表
    get_update_list:function(){
       if(!this.is_update){
          this.is_update = !this.is_update;
       }
       // this.is_leader = false;
       //  this.is_join = false;
       //  this.is_manage = false;
        this.getData('');
    },
    //检查内容是否有更新
    get_change_staus:function(){
      this.desc_update = false;
      this.end_time_update = false;
      this.user_update = false;
      this.documents_update = false;
      this.project_user_update = '';
      for(var i =0; this.visit_log.length > i; i++){
           if (this.visit_log[i].type == 1) {
                this.desc_update = true;
           }else  if (this.visit_log[i].type == 2) {
             this.end_time_update = true;
           }else  if (this.visit_log[i].type == 3) {
             this.user_update= true;
             this.project_user_update= this.visit_log[i].add_user_id;
           }else  if (this.visit_log[i].type == 4) {
             this.documents_update = true;
           }
      }
    },
    //编辑提示
    edit_tips(msg) {
      this.$message(msg);
    },
    //查看更多信息
    more_desc: function(num,name){
      if(this.project_dataInit.description_high > 110) {
        this.projectNum_Name = num + '  ' + name;
        this.descriptionVisible = true;
      }
    },
    onEditorReady(editor) {
    },
  },
  computed: {
    project_customer_names: function(){
      var names = [];
      if(this.project_dataInit.customer_ids.length === undefined) return "";
      for(var i=0;i<this.project_dataInit.customer_ids.length; i++){
        var item = this.project_dataInit.customer_ids[i];
        var show_client = item.khjc === null ? item.khmc: item.khjc;
        if(names.indexOf(show_client) < 0) names.push(show_client);
      }
      return names.join(',');
    },
    project_usernames: function() {
      var usernames = [];

      if(this.project_user_list.length === undefined) return "";
      for(var i=0;i<this.project_user_list.length;i++)
      {
        usernames.push(this.project_user_list[i].username);
      }
      return usernames.join(",");
    },
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  mounted(){
    // this.getTemplate_approval();
    // this.get_approval();
    // this.getDocuments_all();
      // setTimeout(function () {
      //    this.show_save = false;
      // },3000)
  },
  created() {
    this.web_token = sessionStorage.getItem('web_token');
    this.user_info =JSON.parse(sessionStorage.getItem('user_info'));
    this.web_url =  sessionStorage.getItem('web_url');

    this.appUrl = this.web_url + '/download_apk.png'
    this.upload_url = this.web_url+'/document/add';
    this.upload_file_data_approval.web_token = this.web_token;
    
    // this.getData('');
    // this.get_plan_templates();
    // this.getCitys();
    // this.getUsers();
    // this.getCustomer();
    this.getTemplate_approval();
    this.get_approval();
    // this.getDocuments_all();
    // this.getTemplate();
  },
  watch: {
    'project_dataInit':{
      handler(newName, oldName) {

      },
      immediate: true
    },
    'project_data':{
      handler(newName, oldName) {

      },
      immediate: true,
      deeep:true
    },
    'project_user_list':{
      handler(newName, oldName) {
        this.project_user_list_arr = [];
        for(var i=0; i< this.project_user_list.length; i++) {
          this.project_user_list_arr.push(this.project_user_list[i].user_id);
        }
      },
      immediate: true
    },
    'projectsList':{
      handler(newName, oldName) {
        for(var i=0; i< this.projectsList.list.length; i++) {
          if(this.projectsList.list[i].keyword == null){
            this.projectsList.list[i].keyword = '';
            // this.done = true;
          }
        }
        this.projectsItemShow = this.projectsList.list;
      },
      immediate: true
    },
    'description':{
      handler(newName, oldName) {
        var _this = this;
        setTimeout(function () {
          _this.desc_height();
        },200)
      },
      immediate: true
    },
    /*
    'edit_projectData.description':{
      handler(newName, oldName) {
        console.log("edit_projectData.description.watch", newName, oldName);
          this.desc_height();
      },
      immediate: true
    },*/
    'projectData.description':{
      handler(newName, oldName) {
        this.desc_add_height()
      },
      immediate: true
    },
    'search_word': function () {
      this.projectsItemShow = [];
      for(var i=0; i< this.projectsList.list.length; i++) {
        if(this.projectsList.list[i].name.indexOf(this.search_word) > -1 || this.projectsList.list[i].keyword.indexOf(this.search_word) > -1){
              console.log(88888)
             this.projectsItemShow.push(this.projectsList.list[i]);
        }
      }
    }
  },
  components: {
    // // 'v-menu':menu,
    // // 'v-projecttemplate':projecttemplate,
    // 'v-input':inputs,
    // 'v-datepicker':datepicker,
    // 'v-select':selects,
    // 'v-selectObj':selectObj,
    // 'v-text':texts,
    // 'v-selectFile':selectFile,
    // 'v-selectFile_multiple':selectFile_multiple,
    // 'v-select_flow':select_flow,
    // // 'v-next_plan':next_plan,
    // // 'v-header':header,
    // 'v-audit':audit,
    //  "editor":editor,
    // uc_editor
  }
}
</script>



// WEBPACK FOOTER //
// src/page/approval/approval_page.vue